import React from 'react';
import {
  LearningStatusEnum,
  myLearningLessonInfoType,
} from '../../../../constants/types/learning-type';
import ChannelService from '../../../../api/ChannelService';
import { openLearningView } from '../../../../utils/openContentsWindow';
import { putRecentlyLearning } from '../../../../api/utils/api/learningApi';
import { LearningContext } from './LearningContext';

interface LearningLessonItemProps {
  learningId: string;
  lesson: myLearningLessonInfoType;
  onComplete: () => void;
}
const LearningLessonItem = ({
  learningId,
  lesson,
  onComplete,
}: LearningLessonItemProps) => {
  const { setContentView } = React.useContext(LearningContext);

  const clickHandler = async () => {
    openLearningView(learningId, lesson.id, setContentView);
    await putRecentlyLearning(learningId, lesson.id);

    onComplete();
    ChannelService.hideChannelButton();
  };

  const acsessibleType = ['Vimeo', 'HTML'];

  if (lesson && !acsessibleType.includes(lesson.type))
    console.error('지원하지 않는 콘텐츠 타입입니다. Vimeo, HTML만 지원합니다.');

  const getStatusName = (status: LearningStatusEnum) => {
    switch (status) {
      case LearningStatusEnum.NOT_STARTED:
        return '수강 전';
      case LearningStatusEnum.IN_PROGRESS:
        return '수강 중';
      case LearningStatusEnum.COMPLETED:
        return '수강 완료';
      default:
        return '';
    }
  };

  return (
    lesson && (
      <div
        className="h-25 flex cursor-pointer justify-between gap-2 rounded bg-gray0 p-2 hover:bg-gray2 md:gap-4"
        onClick={clickHandler}
      >
        <img
          src={process.env.PUBLIC_URL + lesson.thumbnail}
          alt={lesson.name}
          className="w-16 shrink grow-0 rounded object-cover md:w-20"
        />
        {/* 재생버튼, 콘텐츠 종류가 많아질 경우 사용 */}
        <div className="relative right-0 flex w-5 shrink-0 grow-0 items-center">
          <img
            src={process.env.PUBLIC_URL + '/svg/icon/play-circle.svg'}
            alt={lesson.name}
            className="h-5 w-5 object-cover"
          />
        </div>

        <div className="flex grow flex-col justify-center">
          <div className="text-sm text-black md:text-lg">
            {lesson.lessonName}
          </div>
          <div className="text-md font-bold text-purple5 md:text-xl">
            {lesson.name}
          </div>
          {/* {lesson.type === 'Vimeo' ? 'Video' : lesson.type} */}
        </div>
        <div className="my-auto w-16 shrink-0 grow-0 font-bold">
          {getStatusName(lesson.status)}
        </div>
      </div>
    )
  );
};

export default LearningLessonItem;
